import { Box, Typography } from "@mui/material";
import MainWrapper from "../../components/helpers/MainWrapper";
import Sarodi from "../../images/sarodi-photo.jpg";
import SideBar from "../../components/sidebar";

const WhatIsSarodi = () => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
      }}
    >
      <SideBar />
      <MainWrapper top={{ xs: "15rem", md: "14rem" }}>
        <Box
          sx={{
            objectFit: "contain",
            width: { xs: "90%", md: "100%" },
            height: { xs: "250px", md: "100%" },
          }}
        >
          <img width="100%" height="100%" src={Sarodi} alt="Sarodi Symbol." />
        </Box>
        <Typography
          sx={{
            fontSize: { xs: "12px", md: "14px" },
            color: "#2E2E2E",
            maxWidth: { xs: "90%", md: "100%" },
            textAlign: "justify",
          }}
        >
          ســـــارودی نام تــــــــــجاری جدید ما، برگرفته از تعهد ما به محـــیط
          زیست، شور و اشتیاق ریشه دار و تلاش بی وقفــه مــا بــرای کشــــف راه
          کــار های نوآورانـــه در جهـــت ایجــاد یک زندگــــی پایــدار، نه
          فقـــط بــرای خودمان،بلکه برای کل بشریت می باشد. مـــا بر ایـن
          باوریــم که نام ایمــن آب در عیـــن اینکــه گرامـــی و ارزشمند
          اســـت،دیــگر هویت و هدف جدید مــا را به طور کامـــل پوشــش
          نمیدهــد.ماموریــت ما در ســارودی ایجاد آیـنده ای بــهتر و پایـــدار
          تر بـــرای سیاره مـــا و نســـل های آینــــــده مــی باشد.این نشــان
          دهنــده تـلاش و عـــزم مــا در جــهت ایـــجاد تاثیر مثبت بر محیط زیست
          و الهام بخشیدن به دیــگران برای پیوســــتن به مـــــا در این ســــفر
          تحـــول آفـریـــن می باشد.
        </Typography>
      </MainWrapper>
    </Box>
  );
};

export default WhatIsSarodi;
